export default __webpack_public_path__ + "static/media/zsah4awards.90d2a3fd.png";